<template>
    <form class="o-form">
        <template v-if="isSubmitting">
            <div class="u-bg-color-white o-box">
                <div class="o-box__content">
                    <Spinner />
                </div>
            </div>
        </template>
        <template v-else>
            <div v-if="!success" class="u-bg-color-white o-box">
                <div class="o-box__content">
                    <fieldset>
                        <h3 class="o-title-4 u-mb-xs">Vos informations</h3>
                        <div class="o-text u-mb-xs">
                            <p>Veuillez noter que nous n’acceptons pas d’événements à caractère festif tel que des réceptions ou fêtes.</p>
                        </div>

                        <div class="o-grid -x-sm -y-sm">
                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="organisation" v-model="formData.organisation" placeholder="" required>
                                    <label class="o-label" for="organisation">Organisation *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="facture" v-model="formData.facture" placeholder="">
                                    <label class="o-label" for="facture">Facture à</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="personne-ress" v-model="formData.personneRessource" placeholder="" required>
                                    <label class="o-label" for="personne-ress">Personne ressource *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="email" id="courriel" v-model="formData.courriel" placeholder="" required>
                                    <label class="o-label" for="courriel">Courriel *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group -form-group-flex">
                                    <div class="o-form__group__item">
                                        <input class="o-input" type="text" id="telephone" v-model="formData.telephone" placeholder="" required>
                                        <label class="o-label" for="telephone">Téléphone *</label>
                                    </div>
                                    <div class="o-form__group__item">
                                        <input class="o-input -input-maxw" type="text" id="poste" v-model="formData.poste" placeholder="">
                                        <label class="o-label" for="poste">Poste</label>
                                    </div>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="cellulaire" v-model="formData.cellulaire" placeholder="">
                                    <label class="o-label" for="cellulaire">Cellulaire</label>
                                </div>
                            </div>

                            <div class="o-grid-12">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="adresse" v-model="formData.adresse" placeholder="" required>
                                    <label class="o-label" for="adresse">Adresse *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="ville" v-model="formData.ville" placeholder="" required>
                                    <label class="o-label" for="ville">Ville *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="province" v-model="formData.province" placeholder="" required>
                                    <label class="o-label" for="province">Province *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="code-postal" v-model="formData.codePostal" placeholder="" required>
                                    <label class="o-label" for="code-postal">Code postal *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" id="numero-client" v-model="formData.numeroClient" placeholder="">
                                    <label class="o-label" for="numero-client">Numéro de client</label>
                                </div>
                            </div>

                            <div class="o-grid-12">
                                <div class="o-form__group o-checkbox__group u-mt-xs">
                                    <div class="o-checkbox__wrap">
                                        <input class="o-checkbox" type="checkbox" v-model="formData.changementAdresse" id="choix-1" value="1">
                                        <label class="o-checkbox-label" for="choix-1">
                                            J'ai un numéro de client, mais il y a changement d'adresse
                                        </label>
                                    </div>
                                    <div class="o-checkbox__wrap">
                                        <input class="o-checkbox" type="checkbox" v-model="formData.nouveauClient" id="choix-2" value="1">
                                        <label class="o-checkbox-label" for="choix-2">
                                            Je suis un nouveau client du Centre St-Pierre.
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </fieldset>


                <fieldset>
                    <div v-for="(reservation, frmIndex) in formData.reservations">
                        <div class="o-title-cta u-mb-xs u-mt-md">
                            <h4 class="o-title-4">
                                Réservation No. {{ frmIndex+1 }}
                            </h4>
                            <div v-if="frmIndex>0" class="o-title-cta__link">
                                <div class="o-button-reset -button-reset-flipped">
                                    <input @click.prevent="removeReservation(frmIndex)" type="button" value="Supprimer">
                                    <Image id="trash" class="-ico-trash" />
                                </div>
                            </div>
                        </div>

                        <div class="o-grid -x-sm -y-sm">
                            <div class="o-grid-12">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" :id="'nom-reservation'+frmIndex" v-model="formData.reservations[frmIndex].titreReservation" placeholder="" required>
                                    <label class="o-label" :for="'nom-reservation'+frmIndex">Titre de votre réservation/activité *</label>
                                </div>
                            </div>

                            <div class="o-grid-4">
                                <div class="o-form__group">
                                    <input class="o-input" type="number" :id="'nombre-personne'+frmIndex" v-model="formData.reservations[frmIndex].nombrePersonne" placeholder="" required>
                                    <label class="o-label" :for="'nombre-personne'+frmIndex">Nombre de personne *</label>
                                </div>
                            </div>

                            <div class="o-grid-4">
                                <div class="o-form__group">
                                    <input class="o-input" type="date" :id="'date'+frmIndex" v-model="formData.reservations[frmIndex].date" placeholder="" required>
                                    <label class="o-label" :for="'date'+frmIndex">Date *</label>
                                </div>
                            </div>

                            <div class="o-grid-4">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" :id="'heureDebut'+frmIndex" v-model="formData.reservations[frmIndex].heureDebut" placeholder="" required>
                                    <label class="o-label" :for="'heureDebut'+frmIndex">Heure début *</label>
                                </div>
                            </div>

                            <div class="o-grid-4">
                                <div class="o-form__group">
                                    <input class="o-input" type="text" :id="'heureFin'+frmIndex" v-model="formData.reservations[frmIndex].heureFin" placeholder="" required>
                                    <label class="o-label" :for="'heureFin'+frmIndex">Heure fin *</label>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <label class="sr-only" :for="'type-activite'+frmIndex">Type d'activité</label>
                                    <div class="o-select__wrap">
                                        <select class="o-select" :id="'type-activite'+frmIndex" v-model="formData.reservations[frmIndex].typeActivite">
                                            <option value="" disabled selected>Type d'activité</option>
                                            <option v-for="ta in typesActivite" :value="ta.type">{{ ta.type }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="o-grid-6">
                                <div class="o-form__group">
                                    <label class="sr-only" :for="'salle'+frmIndex">Salle</label>
                                    <div class="o-select__wrap">
                                        <select class="o-select" :id="'salle'+frmIndex" v-model="formData.reservations[frmIndex].salle">
                                            <option value="" disabled selected>Salle</option>
                                            <option v-for="salle in salles" :value="salle.titre" v-html="salle.numero + salle.titre"></option>
                                        </select>
                                    </div>
                                    <div v-if="formData.reservations[frmIndex].salle && !hasMobilite(formData.reservations[frmIndex].salle)" class="u-mt-xs"><strong>Veuillez noter que cette salle est non accessible aux personnes à mobilité réduite.</strong></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="formData.reservations[frmIndex].salle" class="o-box-infos__configs__wrap u-py-md u-bdb-color-4-30">
                            <div class="o-title-5 u-mb-xs o-box-infos__configs__title">
                                Configuration
                            </div>
                            <div class="o-box-infos__configs">
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'theatre')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'t'" value="Théâtre" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'t'">
                                            Théâtre
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-theatre" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'u')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'u'" value="U" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'u'">
                                            U
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-u" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'cercle')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'c'" value="Cercle" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'c'">
                                            Cercle
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-cercle" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'ecole')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'eco'" value="École" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'eco'">
                                            École
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-ecole" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'reunion')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'reu'" value="Réunion" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'reu'">
                                            Réunion
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-reunion" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                                <div v-if="salles.find(s => s.titre == formData.reservations[frmIndex].salle).configurations.find(c => c.configuration == 'ilots')" class="o-box-infos__configs__item">
                                    <div class="o-radio__wrap -radio-col">
                                        <input class="o-radio" type="radio" v-model="formData.reservations[frmIndex].configuration" :id="'choix-radio-'+frmIndex+'ilo'" value="Îlots" required>
                                        <label class="o-radio-label" :for="'choix-radio-'+frmIndex+'ilo'">
                                            Ilots
                                            <div class="o-box-infos__configs__ico">
                                                <Image id="salle-ilots" class="-ico-salle" />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="o-form__group u-mt-md">
                            <textarea class="o-textarea" :id="'notes'+frmIndex" v-model="formData.reservations[frmIndex].note" placeholder=""></textarea>
                            <label class="o-label" :for="'notes'+frmIndex">Notes</label>
                        </div>

                        <div class="o-title-5 u-mt-md u-mb-xs">
                            Équipements et breuvages
                        </div>
                        <div class="o-form__group -form-group-flex">
                            <div class="o-form__group__item">
                                <label class="sr-only" :for="'options'+frmIndex">Options</label>
                                <div class="o-select__wrap">
                                    <select class="o-select" :id="'options'+frmIndex" v-model="formData.reservations[frmIndex]._selectedOption">
                                        <optgroup v-for="group in options" :label="group.groupe">
                                            <option v-for="opt in group.options" :value="opt.option">{{ opt.option }}</option>
                                        </optgroup>
                                    </select>
                                </div>
                            </div>
                            <div class="o-form__group__item">
                                <div class="o-button__wrap">
                                    <span @click="addOption(frmIndex)" class="o-button">
                                        <span class="o-button__text">Ajouter</span>
                                        <svg aria-hidden="true" focusable="false" class="o-ico -ico-plus">
                                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#close"></use>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-for="(opt, optIndex) in reservation.options" class="o-grid -x-sm -y-sm u-mt-xs">
                            <div class="o-grid-4 -grid-middle">
                                {{ opt.option }}
                            </div>
                            <div class="o-grid-8">
                                <div class="o-grid -x-sm -y-sm">
                                    <div class="o-grid-6">
                                        <div class="o-form__group">
                                            <div class="o-form__group__item">
                                                <input class="o-input" type="text" :id="'heure-service-items'+frmIndex+'-'+optIndex" v-model="formData.reservations[frmIndex].options[optIndex].service" placeholder="">
                                                <label class="o-label" :for="'heure-service-items'+frmIndex+'-'+optIndex">Heure de service</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="o-grid-6">
                                        <div class="o-form__group -form-group-flex">
                                            <div class="o-form__group__item">
                                                <input class="o-input" type="text" :id="'nombre-items'+frmIndex+'-'+optIndex" v-model="formData.reservations[frmIndex].options[optIndex].quantite" placeholder="">
                                                <label class="o-label" :for="'nombre-items'+frmIndex+'-'+optIndex">Quantité</label>
                                            </div>
                                            <div class="o-form__group__item">
                                                <div class="o-button__wrap">
                                                    <span @click="removeOption(frmIndex, optIndex)" aria-label="Consulter" class="o-button-circle -button-circle-outline -button-circle-lg">
                                                        <svg aria-hidden="true" focusable="false" class="o-ico -ico-trash"><use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#trash"></use></svg>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="u-mt-md">
                        <div class="o-form__group o-checkbox__group">
                            <div class="o-checkbox__wrap">
                                <input class="o-checkbox" type="checkbox" v-model="formData.acceptationPolitiques" id="choix-5" value="Oui" required>
                                <label class="o-checkbox-label" for="choix-5">
                                    Je reconnais avoir lu, compris et accepté les politiques du service de location de salles du Centre St-Pierre.
                                </label>
                            </div>
                        </div>
                    </div>
                </fieldset>
                </div>
            </div>

            <div v-if="!success" class="o-button__wrap -button-center -button-full-mb u-my-lg">
                <span @click="addReservation()" class="o-button -button-outline">
                    <span class="o-button__text">Ajouter une réservation</span>
                    <svg aria-hidden="true" focusable="false" class="o-ico -ico-plus"><use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#close"></use></svg>
                </span>
                <button @click.prevent="submit()" class="o-button" type="submit" aria-label="Soumettre le formulaire">
                    <span class="o-button__text">Envoyer</span>
                    <span class="sr-only">Soumettre le formulaire</span>
                    <svg aria-hidden="true" focusable="false" class="o-ico -ico-send"><use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=444da4f220674cbd9d#send"></use></svg>
                </button>
            </div>
        </template>
    </form>
    <div v-if="success" id="successmessage" class="o-form__message u-mb-lg">
		<h3 class="o-title-3 u-mb-xs">Nous avons bien reçu votre demande</h3>
		<div class="o-text">
			<p>Merci pour votre réservation, nous vous contacterons sous peu.</p>
		</div>
	</div>
</template>

<script>
    import Image from './image.vue';
    import Spinner from './Spinner.vue';

    export default {
        components: {
            Image,
            Spinner
        },
        props: {
            typesActivite: {
                type: Array,
                required: true
            },
            options: {
                type: Array,
                required: true
            },
            salles: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                success: false,
                isSubmitting: false,
                formData: {
                    organisation:'',
                    facture:'',
                    personneRessource:'',
                    courriel:'',
                    telephone:'',
                    poste:'',
                    cellulaire:'',
                    adresse:'',
                    ville:'',
                    province:'',
                    codePostal:'',
                    numeroClient:'',
                    changementAdresse:0,
                    nouveauClient:0,
                    reservations: [
                        {
                            _selectedOption:'',
                            titreReservation:'',
                            nombrePersonne:'',
                            date:'',
                            heureDebut:'',
                            heureFin:'',
                            typeActivite:'',
                            salle:'',
                            note:'',
                            options:[],
                        }
                    ],
                    acceptationPolitiques: 0,
                }
            }
        },
        methods: {
            hasMobilite(salle) {
                console.log(this.salles)
                let hasMobilite = false;
                this.salles.forEach((s) => {
                    if (s.titre === salle) {
                        hasMobilite = s.mobilite;
                    }
                });

                return hasMobilite;
            },
            addOption(frmIndex) {
                if(!this.formData.reservations[frmIndex]._selectedOption) return;
                this.formData.reservations[frmIndex].options.push({option: this.formData.reservations[frmIndex]._selectedOption, quantite: 1});
            },
            removeOption(frmIndex, optIndex) {
                this.formData.reservations[frmIndex].options.splice(optIndex, 1);
            },
            removeReservation(frmIndex) {
                this.formData.reservations.splice(frmIndex, 1);
            },
            addReservation() {
                this.formData.reservations.push({
                    _selectedOption:'',
                    titreReservation:'',
                    nombrePersonne:'',
                    date:'',
                    heureDebut:'',
                    heureFin:'',
                    typeActivite:'',
                    salle:'',
                    note:'',
                    options:[],
                    configuration:'',
                });
            },
            submit()
            {
                this.isSubmitting = true;
                // verif required fields
                let requiredFields = ['organisation', 'personneRessource', 'courriel', 'telephone', 'adresse', 'ville', 'province', 'codePostal', 'acceptationPolitiques'];
                let valid = true;
                requiredFields.forEach((field) => {
                    if (!this.formData[field]) {
                        valid = false;
                        this.isSubmitting = false;
                    }
                });

                // verif required fields in reservations
                this.formData.reservations.forEach((reservation) => {
                    let requiredFields = ['nombrePersonne', 'date', 'heureDebut', 'heureFin'];
                    requiredFields.forEach((field) => {
                        if (!reservation[field]) {
                            valid = false;
                            this.isSubmitting = false;
                        }
                    });
                });

                if (valid) {
                    // send form
                    let _title_field = this.formData.organisation ? 'organisation' : 'personneRessource';
                    let formData = new FormData();
                    formData.append('action', 'st_post_contact');
                    formData.append('_subject', 'Nouvelle réservation');
                    formData.append('_title_field', _title_field);
                    formData.append('_category', 'Réservation de salle');
                    formData.append('_nobot', '1');
                    formData.append('organisation', this.formData.organisation);
                    formData.append('facture', this.formData.facture);
                    formData.append('personneRessource', this.formData.personneRessource);
                    formData.append('courriel', this.formData.courriel);
                    formData.append('telephone', this.formData.telephone);
                    formData.append('poste', this.formData.poste);
                    formData.append('cellulaire', this.formData.cellulaire);
                    formData.append('adresse', this.formData.adresse);
                    formData.append('ville', this.formData.ville);
                    formData.append('province', this.formData.province);
                    formData.append('codePostal', this.formData.codePostal);
                    formData.append('numeroClient', this.formData.numeroClient);
                    formData.append('changementAdresse', this.formData.changementAdresse);
                    formData.append('nouveauClient', this.formData.nouveauClient);
                    formData.append('acceptationPolitiques', this.formData.acceptationPolitiques);

                    this.formData.reservations.forEach((reservation, index) => {
                        formData.append('reservations['+index+'][titreReservation]', reservation.titreReservation);
                        formData.append('reservations['+index+'][nombrePersonne]', reservation.nombrePersonne);
                        formData.append('reservations['+index+'][date]', reservation.date);
                        formData.append('reservations['+index+'][heureDebut]', reservation.heureDebut);
                        formData.append('reservations['+index+'][heureFin]', reservation.heureFin);
                        formData.append('reservations['+index+'][typeActivite]', reservation.typeActivite);
                        formData.append('reservations['+index+'][salle]', reservation.salle);
                        formData.append('reservations['+index+'][note]', reservation.note);
                        formData.append('reservations['+index+'][configuration]', reservation.configuration);

                        reservation.options.forEach((option, optIndex) => {
                            formData.append('reservations['+index+'][options]['+optIndex+'][option]', option.option);
                            formData.append('reservations['+index+'][options]['+optIndex+'][service]', option.service);
                            formData.append('reservations['+index+'][options]['+optIndex+'][quantite]', option.quantite);
                        });
                    });

                    fetch(WPURLS.ajaxurl, {
                        method: 'POST',
                        credentials: "same-origin",
                        body: formData
                    })
                    .then(response => {
                        //if (data.success) {
                            this.success = true;
                            this.isSubmitting = false;
                            //Wait 1 sec and scroll to success message
                            setTimeout(() => {
                                document.getElementById('successmessage').scrollIntoView({behavior: 'smooth'});
                            }, 1000);
                        //}
                    });
                } else {
                    alert('Veuillez remplir tous les champs obligatoires');
                }
            }
        }
    }
</script>